import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import classNames from 'classnames';
import HighlightsStarIcon from 'components/Icons/HighlightsStarIcon';

import styles from './CamHighlightsPill.module.scss';

interface CamHighlightsPillProps {
  displayLabel: string;
  /** Use with VideoPlayer `skin="minimal"` so the pill lines up with top play / fullscreen controls */
  variant?: 'default' | 'minimalPlayer';
}

const CamHighlightsPill = ({ displayLabel, variant = 'default' }: CamHighlightsPillProps) => {
  return (
    <Box
      className={classNames(styles.pill, {
        [styles.pillMinimalPlayer]: variant === 'minimalPlayer',
      })}
    >
      <HighlightsStarIcon />
      <Typography color="white" variant="callout2">
        {displayLabel}
      </Typography>
    </Box>
  );
};

CamHighlightsPill.displayName = 'CamHighlightsPill';

export default React.memo(CamHighlightsPill);
